import { useContext, useEffect, useState } from "react";
import Input from "../../material/input/Input";
import Select from "../../material/select/Select";
import Breadcrumb from "../breacrumb/breadcrumb";
import Footer from "../footer/Footer";
import HeadBar from "../headBar/HeadBar";
import * as publicApi from "../../../service/publicApi";
import * as regex from "../../../service/regex";
import Button from "../../material/button/Button";
import { useNavigate } from "react-router-dom";

import { CurrentUserContext } from "../../../App";
import PageHeader from "../../pageheader/PageHeader";

export default function ForgotPassword() {
  const nav = useNavigate();
  const { setIsMessage } = useContext(CurrentUserContext);
  const [role, setRole] = useState("PATIENT");
  const [pid, setPid] = useState("");
  // const disablePid = useRef(false);

  useEffect(() => {
    localStorage.clear();
  });

  const pathItems = [
    { name: "หน้าหลัก", url: "/" },
    { name: "ลืมรหัสผ่าน", url: "/forgotPassword" },
  ];

  const handleSelect = (key) => {
    setRole(key);
  };
  const handlePidChange = (e) => {
    setPid(e);
  };

  let roleList = [
    {
      key: "PATIENT",
      value: "ประชาชนทั่วไป",
    },
    {
      key: "MEDICAL_PERSONNEL",
      value: "แพทย์/เภสัช",
    },
    {
      key: "LABORATORY_ADMIN",
      value: "ผู้ดูแลห้องปฏิบัติการ",
    },
    {
      key: "LABORATORY_PERSONNEL",
      value: "ผู้ปฏิบัติการในห้องปฏิบัติการ",
    },
    {
      key: "HOSPITAL_PERSONNEL",
      value: "เจ้าหน้าที่โรงพยาบาล",
    },
    {
      key: "EXECUTIVE",
      value: "ผู้บริหาร",
    },
    {
      key: "HOSPITAL",
      value: "โรงพยาบาล",
    },
    {
      key: "ADMIN",
      value: "ผู้ดูแลระบบ/แอดมิน",
    },
  ];

  const onClickSubmit = async () => {
    if (!role) {
      setIsMessage({
        type: "warning",
        data: "กรุณาเลือกประเภทของผู้เข้าใช้งาน",
      });
      return;
    } else if (!pid) {
      setIsMessage({
        type: "warning",
        data: "กรุณากกรอกเลขบัตรประจำตัวประชาชน",
      });
      return;
    }
    let body = {
      role: role,
      id_card: pid,
    };
    const res = await publicApi.forgotPassword(body);
    if (res) {
      // console.log(res);
      if (res["data"]["code"] === 200) {
        nav("/forgotPassword/confirmTel", {
          state: {
            phone_number: res["data"]["data"]["phone_number"],
            token: res["data"]["data"]["token"],
          },
        });
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };
  return (
    <>
      <div className="global-page">
        <Breadcrumb pathItems={pathItems} />
        <div className="w-full flex justify-center items-center">
          <PageHeader titlename={"ลืมรหัสผ่าน"} />
        </div>

        <div className="flex flex-col items-center gap-5 my-[50px] w-full">
          <div className="w-[600px]">
            <div className="sm:w-full flex flex-col">
              <Select
                label="เลือกประเภทของผู้เข้าใช้งาน"
                // placeholder="เลือกประเภทของผู้เข้าใช้งาน"
                value={role}
                setValue={handleSelect}
                list={roleList}
              ></Select>
            </div>
            <div className="sm:hidden w-full h-[1px] bg-gray-300 my-5"></div>
            <div className="sm:w-full flex flex-col">
              <Input
                regex={regex.pid()}
                disabled={false}
                placeholder="เลขบัตรประจำตัวประชาชน (กรอกตัวเลขไม่ต้องใส่ขีด)"
                value={pid}
                setValue={handlePidChange}
                label="เลขบัตรประจำตัวประชาชน (กรอกตัวเลขไม่ต้องใส่ขีด)"
              ></Input>
            </div>
            <div className="">
              <Button onClick={onClickSubmit}>ขอตั้งรหัสผ่านใหม่</Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
